import * as actionTypes from './actionTypes';
import axios from '../../_services/api/axios'

/* ----------------- Auth ------------------ */
export const authSetMelcoAccountData = (token, user_id, first_name, last_name) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user_id', user_id);

    return {
        type: actionTypes.AUTH_SET_MELCO_ACCOUNT_DATA,
    };
};

export const authRemoveMelcoAccountData = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');

    return {
        type: actionTypes.AUTH_REMOVE_MELCO_ACCOUNT_DATA,
    };
};

export const authChangeCurrentUser = (token, user_id, first_name, last_name, account_name, parent_user_id, impersonation_for_id) => {

    return {
        type: actionTypes.AUTH_CHANGE_CURRENT_USER,
        token: token,
        user_id: user_id,
        warning: false,
		first_name:first_name,
		last_name:last_name,
        account_name:account_name,
        parent_user_id:parent_user_id,
        impersonation_for_id:impersonation_for_id
    };
}

export const authLogoutOnServerSuccess = () => {
    return {
        type: actionTypes.AUTH_LOGOUT_ON_SERVER_SUCCESS
    };
};

export const authLogoutOnServerFail = ( error ) => {
    return {
        type: actionTypes.AUTH_LOGOUT_ON_SERVER_FAIL,
        error: error
    };
};

export const authLogoutOnServerStart = () => {
    return {
        type: actionTypes.AUTH_LOGOUT_ON_SERVER_START
    };
};

export const authLogoutOnServer = (id) => {
    return dispatch => {
        dispatch(authLogoutOnServerStart());
        axios.delete( '/auth/melco/logoff' )
            .then( response => {
                dispatch( authLogoutOnServerSuccess( ) );
                dispatch( authRemoveMelcoAccountData( ) );

                window.location.href = `${process.env.REACT_APP_ACCOUNT_URL}?logout-success&redirectTo=${process.env.REACT_APP_APP_URL}`;
            } )
            .catch( error => {
                dispatch( authLogoutOnServerFail( error ) );
            } );
    };
};


// WEBPACK FOOTER //
// ./src/_store/actions/auth.js